import React, { useState, useRef } from 'react'

const DataCacheContext = React.createContext({})

export const DataCacheProvider = (props) => {
    const [dataCache, setDataCache] = useState({});
    const es = props.es;
    const setLastUpdate = props.setLastUpdate;
    // registry to keep track of listeners and prevent duplicates
    const listenerRegistryRef = useRef({});
    const esListenerRegistryRef = useRef({});

    const startWorkerUpdater = (endpoint, updateDelay) => {
        let updateWorker = new Worker('/updateWorker.js');
        updateWorker.postMessage({ msg: "connect", apiUrl: process.env.REACT_APP_API_HOST + "/" + endpoint, type: endpoint, updateDelay: updateDelay });
        
        // track event source listener reference 
        const esListener = (e) => {
            updateWorker.postMessage({msg:"update", data:e.data});
            setLastUpdate(lastUpdate => {
                let now = new Date();
                if(now.getTime() - lastUpdate.getTime() > 60000) {
                    return now;
                } else {
                    return lastUpdate;
                }
            });
        };
        es.addEventListener(endpoint, esListener);
        esListenerRegistryRef.current[endpoint] = esListener;
        
        return updateWorker;
    }

    return (
        <DataCacheContext.Provider
            value={{
                es: es,
                data: dataCache,
                createDataCache: (endpoint, updateDelay, objectsListener) => {
                    if (dataCache[endpoint]) {
                        // check if this listener is already registered 
                        if (!listenerRegistryRef.current[endpoint]) {
                            listenerRegistryRef.current[endpoint] = new Set();
                        }
                        
                        // add if this listener isn't already registered
                        if (!listenerRegistryRef.current[endpoint].has(objectsListener)) {
                            const listenerWrapper = function (e) {
                                objectsListener(e);
                            };
                            dataCache[endpoint].addEventListener('message', listenerWrapper);
                            listenerRegistryRef.current[endpoint].add(objectsListener);
                        }
                        
                        dataCache[endpoint].postMessage({ msg: "resume" });
                        return dataCache[endpoint];
                    } 
                    else {
                        setDataCache(dataCache => {
                            let newDataCache = { ...dataCache };
                            newDataCache[endpoint] = startWorkerUpdater(endpoint, updateDelay);
                            
                            // initialize registry for this endpoint
                            if (!listenerRegistryRef.current[endpoint]) {
                                listenerRegistryRef.current[endpoint] = new Set();
                            }
                            
                            const listenerWrapper = function (e) {
                                objectsListener(e);
                            };
                            newDataCache[endpoint].addEventListener('message', listenerWrapper);
                            listenerRegistryRef.current[endpoint].add(objectsListener);
                            
                            return newDataCache;
                        });
                    }
                }
            }}>{props.children}
        </DataCacheContext.Provider>
    )

}
export const DataCacheConsumer = DataCacheContext.Consumer;

export default DataCacheContext